/**
 * Mobile Accordion Menu Fix v7
 * ============================
 * 配合修改后的 theme.js 使用（theme.js 中添加了 window.__accordionMenuEnabled 守卫）
 *
 * 原理：
 *   theme.js 的 menuSidebarMobileToggle() 函数在最开头检查
 *   if (window.__accordionMenuEnabled) return;
 *   本脚本在加载时设置该标志为 true，完全禁用主题的 slide-in 面板行为。
 *   然后通过 capture 阶段的 document 事件监听器实现手风琴菜单。
 *
 * 不再需要外部浮层（External Overlay）方案，因为主题的点击拦截已被关闭。
 *
 * 菜单结构：
 *   .halo-sidebar_menu > .site-nav-mobile
 *     LV1: .menu-lv-1 (.has-megamenu → .menu-dropdown) / (.no-megamenu.dropdown → .list-menu--disclosure-1)
 *     LV2 megamenu: .site-nav.dropdown → .site-nav-sub
 *     LV2 disclosure: .menu-lv-2.dropdown → .list-menu--disclosure-2
 *
 * 行为规格：
 *   - LV1 父级菜单（有 .dropdown）：点击展开/收起（手风琴互斥），不导航
 *   - LV1 叶子节点（无 .dropdown）：正常导航到自身 URL
 *   - "Shop by Type"：自动展开，不可收起
 *   - LV2 有子菜单项：点击展开/收起
 *   - LV2/LV3 叶子节点：正常导航到自身 URL
 *   - "Go to xxx" 链接 / .navigation_all_mobile / .nav-title-mobile：全部隐藏
 */
(function () {
  'use strict';

  /* ===== 核心：禁用主题 slide-in 行为 ===== */
  window.__accordionMenuEnabled = true;

  var MENU_SELECTOR = '.halo-sidebar_menu';
  var AUTO_EXPAND_TITLES = ['shop by type'];

  /* ─── 工具函数 ─── */

  function textOf(el) {
    if (!el) return '';
    var clone = el.cloneNode(true);
    clone.querySelectorAll('svg, .icon-dropdown, .icon').forEach(function (ic) { ic.remove(); });
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function isAutoExpandTitle(title) {
    var t = title.toLowerCase();
    for (var i = 0; i < AUTO_EXPAND_TITLES.length; i++) {
      if (t === AUTO_EXPAND_TITLES[i]) return true;
    }
    return false;
  }

  /* ─── Go To 链接清理 ─── */

  function cleanupGoToLinks(container) {
    if (!container) return;

    // 使用 cssText 设置 !important，确保覆盖其他 CSS 规则
    var hideStyle = 'display:none!important;height:0!important;padding:0!important;margin:0!important;overflow:hidden!important;';

    // 隐藏 .navigation_all_mobile（megamenu 模板的 "Go to xxx"）
    container.querySelectorAll('.navigation_all_mobile').forEach(function (el) {
      el.style.cssText = hideStyle;
    });

    // 隐藏 .nav-all-mobile（non-megamenu 模板的 "Go to xxx"）
    container.querySelectorAll('.nav-all-mobile').forEach(function (el) {
      el.style.cssText = hideStyle;
    });

    // 隐藏 .nav-title-mobile（返回按钮 / 面板标题）
    container.querySelectorAll('.nav-title-mobile').forEach(function (el) {
      el.style.cssText = hideStyle;
    });

    // 确保 .d-none 元素不被意外显示
    container.querySelectorAll('.d-none').forEach(function (el) {
      el.style.cssText = hideStyle;
    });

    // 隐藏所有以 "Go to" / "Go To" 开头的链接
    container.querySelectorAll('a').forEach(function (a) {
      var t = textOf(a).toLowerCase();
      if (t.indexOf('go to ') === 0) {
        var parent = a.closest('li, .site-nav-item, .site-nav, div');
        if (parent) parent.style.cssText = hideStyle;
      }
    });
  }

  /* ─── 自动展开 "Shop by Type" ─── */

  function markAutoExpand(container) {
    if (!container) return;
    container.querySelectorAll('.site-nav.dropdown').forEach(function (nav) {
      if (nav.classList.contains('is-auto-expand')) return;
      var titleEl = nav.querySelector('.site-nav-title');
      if (!titleEl) return;
      var titleLink = titleEl.querySelector('a');
      var title = titleLink ? textOf(titleLink) : textOf(titleEl);
      if (isAutoExpandTitle(title)) {
        nav.classList.add('is-auto-expand', 'is-open');
        var sub = nav.querySelector('.site-nav-sub');
        if (sub) {
          sub.style.cssText = 'position:static!important;transform:none!important;width:100%!important;height:auto!important;max-height:5000px!important;opacity:1!important;visibility:visible!important;overflow:visible!important;pointer-events:auto!important;';
          // 只显示非 "Go to" 的子项，排除 .navigation_all_mobile / .d-none / .nav-all-mobile
          sub.querySelectorAll('.site-nav-item:not(.navigation_all_mobile):not(.d-none):not(.nav-all-mobile)').forEach(function (item) {
            item.style.cssText = 'display:block!important;visibility:visible!important;opacity:1!important;';
          });
          // 确保 "Go to" 子项被隐藏
          sub.querySelectorAll('.site-nav-item.navigation_all_mobile, .site-nav-item.d-none, .site-nav-item.nav-all-mobile').forEach(function (item) {
            item.style.cssText = 'display:none!important;';
          });
        }
        // 隐藏箭头、标题不可点击
        var icon = nav.querySelector('.site-nav-title .icon-dropdown');
        if (icon) icon.style.display = 'none';
        if (titleLink) titleLink.style.fontWeight = '600';
        titleEl.style.pointerEvents = 'none';
        titleEl.style.cursor = 'default';
      }
    });
  }

  /* ─── 样式操作 ─── */

  function applyOpenStyles(li) {
    // Megamenu: .menu-dropdown
    var dropdown = li.querySelector('.menu-dropdown');
    if (dropdown) {
      dropdown.style.cssText = 'position:static!important;transform:none!important;-webkit-transform:none!important;width:100%!important;height:auto!important;max-height:5000px!important;opacity:1!important;visibility:visible!important;overflow:visible!important;padding:0!important;background:#fff!important;z-index:auto!important;top:auto!important;left:auto!important;right:auto!important;pointer-events:auto!important;';
      // 内部元素
      dropdown.querySelectorAll('.site-nav:not(.navigation_all_mobile):not(.d-none)').forEach(function (nav) {
        nav.style.cssText = 'visibility:visible!important;opacity:1!important;position:static!important;transform:none!important;height:auto!important;width:100%!important;pointer-events:auto!important;';
      });
      // 确保 "Go to" 导航项保持隐藏
      dropdown.querySelectorAll('.site-nav.navigation_all_mobile, .navigation_all_mobile, .nav-all-mobile').forEach(function (el) {
        el.style.cssText = 'display:none!important;';
      });
      dropdown.querySelectorAll('.site-nav-list').forEach(function (el) {
        el.style.cssText = 'visibility:visible!important;opacity:1!important;position:static!important;';
      });
      dropdown.querySelectorAll('.menu-dropdown__wrapper').forEach(function (el) {
        el.style.cssText = 'position:static!important;width:100%!important;overflow:visible!important;display:block!important;';
      });
      dropdown.querySelectorAll('.menu-dropdown__column').forEach(function (el) {
        el.style.cssText = 'width:100%!important;';
      });
      dropdown.querySelectorAll('.container').forEach(function (el) {
        el.style.cssText = 'padding-left:0!important;padding-right:0!important;';
      });
      dropdown.querySelectorAll('.menu-dropdown__banner').forEach(function (el) {
        el.style.display = 'none';
      });
    }

    // Disclosure: .list-menu--disclosure-1
    var disclosure1 = li.querySelector('.list-menu--disclosure-1');
    if (disclosure1) {
      disclosure1.style.cssText = 'position:static!important;transform:none!important;width:100%!important;height:auto!important;max-height:5000px!important;opacity:1!important;visibility:visible!important;overflow:visible!important;padding:0!important;background:#fff!important;pointer-events:auto!important;';
    }
  }

  function clearInlineStyles(li) {
    var dropdown = li.querySelector('.menu-dropdown');
    if (dropdown) {
      dropdown.style.cssText = '';
      dropdown.querySelectorAll('.site-nav, .site-nav-list, .menu-dropdown__wrapper, .menu-dropdown__column, .container, .menu-dropdown__banner').forEach(function (el) {
        el.style.cssText = '';
      });
    }
    var disclosure1 = li.querySelector('.list-menu--disclosure-1');
    if (disclosure1) disclosure1.style.cssText = '';

    li.querySelectorAll('.site-nav-sub').forEach(function (s) { s.style.cssText = ''; });
    li.querySelectorAll('.site-nav-item').forEach(function (item) { item.style.cssText = ''; });
    li.querySelectorAll('.list-menu--disclosure-2, .menu-lv__dropdownmenu-2').forEach(function (d) { d.style.cssText = ''; });
    li.querySelectorAll('.site-nav.is-open').forEach(function (n) { n.classList.remove('is-open'); });
    li.querySelectorAll('.site-nav.is-auto-expand').forEach(function (n) {
      n.classList.remove('is-auto-expand');
      // Restore styles set by markAutoExpand on child elements
      var titleEl = n.querySelector('.site-nav-title');
      if (titleEl) { titleEl.style.pointerEvents = ''; titleEl.style.cursor = ''; }
      var titleLink = n.querySelector('a.site-nav-title');
      if (titleLink) titleLink.style.fontWeight = '';
      var icon = n.querySelector('.site-nav-title .icon-dropdown');
      if (icon) icon.style.display = '';
    });
    li.querySelectorAll('.menu-lv-2.is-open').forEach(function (n) { n.classList.remove('is-open'); });
  }

  /* ─── LV1 点击处理（手风琴互斥） ─── */

  function handleLv1Click(li) {
    var root = li.closest(MENU_SELECTOR);
    if (!root) return;

    var wasOpen = li.classList.contains('is-open');

    // 手风琴互斥：关闭其他 LV1
    root.querySelectorAll('.menu-lv-1.is-open').forEach(function (other) {
      if (other !== li) {
        other.classList.remove('is-open');
        clearInlineStyles(other);
      }
    });

    // 切换当前项
    if (wasOpen) {
      li.classList.remove('is-open');
      clearInlineStyles(li);
    } else {
      li.classList.add('is-open');
      applyOpenStyles(li);
      markAutoExpand(li);
      // cleanupGoToLinks 必须在 applyOpenStyles 和 markAutoExpand 之后运行
      cleanupGoToLinks(li);
    }
  }

  /* ─── LV2 Megamenu 标题点击 ─── */

  function handleMegaLv2Click(nav) {
    if (nav.classList.contains('is-auto-expand')) return; // 自动展开不可收起

    nav.classList.toggle('is-open');
    var sub = nav.querySelector('.site-nav-sub');
    if (sub) {
      if (nav.classList.contains('is-open')) {
        sub.style.cssText = 'position:static!important;transform:none!important;width:100%!important;height:auto!important;max-height:5000px!important;opacity:1!important;visibility:visible!important;overflow:visible!important;pointer-events:auto!important;';
        cleanupGoToLinks(nav);
      } else {
        sub.style.cssText = '';
      }
    }
  }

  /* ─── LV2 Disclosure 标题点击 ─── */

  function findDiscSubmenu(li) {
    return li.querySelector('.list-menu--disclosure-2') || li.querySelector('.menu-lv__dropdownmenu-2');
  }

  function handleDiscLv2Click(li) {
    // 手风琴互斥（同级 LV2）
    var parent = li.parentElement;
    if (parent) {
      parent.querySelectorAll(':scope > .menu-lv-2.is-open').forEach(function (other) {
        if (other !== li) {
          other.classList.remove('is-open');
          var d = findDiscSubmenu(other);
          if (d) d.style.cssText = '';
        }
      });
    }

    li.classList.toggle('is-open');
    var disc = findDiscSubmenu(li);
    if (disc) {
      if (li.classList.contains('is-open')) {
        disc.style.cssText = 'position:static!important;transform:none!important;width:100%!important;height:auto!important;max-height:5000px!important;opacity:1!important;visibility:visible!important;overflow:visible!important;pointer-events:auto!important;';
        cleanupGoToLinks(li);
      } else {
        disc.style.cssText = '';
      }
    }
  }

  /* ─── 点击事件代理（capture 阶段） ─── */

  document.addEventListener('click', function (e) {
    // 只处理 sidebar 菜单内的点击
    var menuRoot = e.target.closest(MENU_SELECTOR);
    if (!menuRoot) return;

    var target = e.target;

    // 1. 检查是否点击了 LV1 的 <a> 或其内部元素（如 .icon-dropdown）
    var lv1Link = target.closest('.menu-lv-1 > a.menu_mobile_link');
    if (lv1Link) {
      var lv1Item = lv1Link.closest('.menu-lv-1');
      // 只有有子菜单的 LV1 才拦截（.dropdown 类）
      if (lv1Item && lv1Item.classList.contains('dropdown')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        handleLv1Click(lv1Item);
        return;
      }
      // 叶子节点 LV1：正常导航，不拦截
      return;
    }

    // 2. 检查是否点击了 Megamenu LV2 标题（a.site-nav-title 或 .menu_mobile_link_2）
    //    HTML 结构: .site-nav.dropdown > .site-nav-list > a.site-nav-title
    var megaTitleLink = target.closest('a.site-nav-title, a.menu_mobile_link_2');
    if (megaTitleLink) {
      // 先检查是否在 .site-nav.dropdown 内（megamenu 模板）
      var siteNav = megaTitleLink.closest('.site-nav.dropdown');
      if (siteNav && siteNav.querySelector('.site-nav-sub')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        handleMegaLv2Click(siteNav);
        return;
      }
      // 再检查是否在 .menu-lv-2.dropdown 内（disclosure 模板，<a> 在 .site-nav-list-dropdown 包装层内）
      var lv2Parent = megaTitleLink.closest('.menu-lv-2.dropdown');
      if (lv2Parent && (lv2Parent.querySelector('.list-menu--disclosure-2') || lv2Parent.querySelector('.menu-lv__dropdownmenu-2'))) {
        e.preventDefault();
        e.stopImmediatePropagation();
        handleDiscLv2Click(lv2Parent);
        return;
      }
    }

    // 3. 检查是否点击了 Disclosure LV2 的 <a>（直接子级或嵌套在 .site-nav-list-dropdown 内）
    var discLink = target.closest('.menu-lv-2.dropdown > a') || target.closest('.menu-lv-2.dropdown > .site-nav-list-dropdown > a');
    if (discLink) {
      var lv2Item = discLink.closest('.menu-lv-2.dropdown');
      // 支持两种子菜单容器: .list-menu--disclosure-2 (某些模板) 和 .menu-lv__dropdownmenu-2 (halo-navigation-mobile-list)
      if (lv2Item && (lv2Item.querySelector('.list-menu--disclosure-2') || lv2Item.querySelector('.menu-lv__dropdownmenu-2'))) {
        e.preventDefault();
        e.stopImmediatePropagation();
        handleDiscLv2Click(lv2Item);
        return;
      }
    }

    // 4. 其他点击（叶子节点链接等）：正常导航，不拦截

  }, true); // capture 阶段，先于其他任何处理器

  /* ─── 修复主题隐藏的菜单项 ─── */

  function fixHiddenItems(root) {
    if (!root) return;
    root.querySelectorAll('.menu-lv-1').forEach(function (li) {
      if (li.style.display === 'none') {
        li.style.display = '';
      }
    });
  }

  /* ─── 初始化 ─── */

  function init() {
    var menuRoot = document.querySelector(MENU_SELECTOR);
    if (!menuRoot) return;

    cleanupGoToLinks(menuRoot);
    fixHiddenItems(menuRoot);

    // 监听 DOM 变化（主题可能动态重建菜单）
    var observer = new MutationObserver(function () {
      var root = document.querySelector(MENU_SELECTOR);
      if (root) {
        fixHiddenItems(root);
        cleanupGoToLinks(root);
      }
    });
    observer.observe(menuRoot, { childList: true, subtree: true });
  }

  /* ═══════════════════════════════════════════════════════════════
   *  Mobile Nav Banner — 纯 JS 注入
   *  ═══════════════════════════════════════════════════════════════
   *  编辑说明：
   *    1. show_banner 设为 true 开启，false 关闭
   *    2. 替换 banner_image 为你的图片 URL
   *    3. 修改 card 部分的标题、描述、按钮
   *  ═══════════════════════════════════════════════════════════════ */
  var BANNER_CONFIG = {
    show_banner:   true,
    /* ── 顶部大图 ── */
    banner_image:  '',
    banner_link:   '/',
    banner_radius: '8px',
    /* ── 底部卡片 ── */
     card_image:    'https://cdn.shopify.com/s/files/1/0673/9669/8337/files/Signature_Hardwood_Collection.jpg?v=1775239085',
    card_title: 'Use Code <strong>NEWSHOP350</strong> at Checkout',
    card_desc:     'Shop our signature hardwood collection ',
    card_btn_text: 'Explore In Stock Now',
    card_btn_link: '/collections/Golden State Floors Hardwood options'
  };

  function buildBannerHTML(cfg) {
    if (!cfg.show_banner) return '';
    var h = '<div class="mobile-nav-banner">';

    if (cfg.banner_image) {
      h += '<div class="mobile-nav-banner__hero">';
      if (cfg.banner_link) h += '<a href="' + cfg.banner_link + '">';
      h += '<img src="' + cfg.banner_image + '" alt="' + (cfg.card_title || 'Banner') + '" loading="lazy" style="border-radius:' + cfg.banner_radius + ';">';
      if (cfg.banner_link) h += '</a>';
      h += '</div>';
    }

    if (cfg.card_image || cfg.card_title || cfg.card_desc) {
      h += '<div class="mobile-nav-banner__card">';
      if (cfg.card_image) {
        h += '<div class="mobile-nav-banner__card-img">';
        h += '<img src="' + cfg.card_image + '" alt="' + (cfg.card_title || '') + '" loading="lazy" style="border-radius:' + cfg.banner_radius + ';">';
        h += '</div>';
      }
      h += '<div class="mobile-nav-banner__card-body">';
      if (cfg.card_title) h += '<h3 class="mobile-nav-banner__card-title">' + cfg.card_title + '</h3>';
      if (cfg.card_desc)  h += '<p class="mobile-nav-banner__card-desc">' + cfg.card_desc + '</p>';
      if (cfg.card_btn_text && cfg.card_btn_link) {
        h += '<a href="' + cfg.card_btn_link + '" class="mobile-nav-banner__card-btn">' + cfg.card_btn_text + '</a>';
      }
      h += '</div></div>';
    }
    h += '</div>';
    return h;
  }

  function injectBanner() {
    var sidebar = document.querySelector('.halo-sidebar_menu .halo-sidebar-wrapper');
    if (!sidebar || sidebar.querySelector('.mobile-nav-banner')) return;
    var html = buildBannerHTML(BANNER_CONFIG);
    if (!html) return;

    // Insert AFTER nav-currency-language (below My Wish List), or append at end
    var navCurrency = sidebar.querySelector('.nav-currency-language');

    var wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    var bannerEl = wrapper.firstChild;
    if (navCurrency && navCurrency.nextSibling) {
      sidebar.insertBefore(bannerEl, navCurrency.nextSibling);
    } else {
      sidebar.appendChild(bannerEl);
    }
  }

  // DOM Ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      init();
      setupBannerObserver();
    });
  } else {
    init();
    setupBannerObserver();
  }

  function setupBannerObserver() {
    // Theme uses body.menu_open to indicate sidebar is open
    // Inject immediately if already open
    if (document.body.classList.contains('menu_open')) {
      setTimeout(injectBanner, 150);
    }
    // Watch body class for menu_open
    var mo = new MutationObserver(function() {
      if (document.body.classList.contains('menu_open')) {
        setTimeout(injectBanner, 200);
      }
    });
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
})();
